var map = {
	"./Balanand Vidhyalay/logo.webp": 988,
	"./Bhagwati Vidhyalaya/logo.webp": 4477,
	"./Gadhpur Vidhyalay/logo.webp": 1662,
	"./Gyandeep Vidhyalaya/logo.webp": 5193,
	"./Gyanganga Global School/logo.webp": 5308,
	"./Harekrushna Vidhyalaya/logo.webp": 7840,
	"./Nilkanth Kanya Vidhyalaya/logo.webp": 7003,
	"./Nilmadhav Vidhyalaya/logo.webp": 9822,
	"./Surat Diamond Girls Association School/logo.webp": 8377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 492;